import React, {FC, ReactElement, useEffect, useState} from 'react';
import './Icon.scss';
import styled from 'styled-components';
import { environment } from '../../../environments/environment';

interface iconProps {
    icon: any,
    fontSize: string,
    color: string,
    horizontalAlignment: string,
    isLinkActive: boolean,
    linkUrl: string,
    linkAnalyticEvent: string,
    isOpenLinkInNewTab: boolean,
    anchorName:string,
    anchorTrigger: string,
    selectedLinkType: string | null,
    editorPlugins: Record<string, any>
};

interface iconWrapperProps {
    horizontalAlignment: string;
};

interface iconElementProps {
    fontSize: string,
    color: string
};

const IconWrapper = styled.div<iconWrapperProps>`
&.iconWrapper {
    position: relative;
    justify-content: ${props => props.horizontalAlignment || 'inherit'};
    .icon-container {
        position: relative;
    }
}`;

const IconElement = styled.span<iconElementProps>`
&.material-icons {
    font-size: ${props => props.fontSize + 'px' || '24px'} !important;
    color: ${props => props.color || 'inherit'};
}
`;

const Icon: FC<iconProps> = ({ ...props }): ReactElement => {

    const [ size, setSize ] = useState<string>(props.fontSize)
    const emitSize = (size: string): void => setSize(size);
    const ResizeRatio = props.editorPlugins?.ResizeRatio;
    useEffect(() => setSize(props.fontSize), [ props.fontSize ]);

    if ((props.isLinkActive && !props.selectedLinkType) || props.selectedLinkType === 'hyperlink') {
        return (
            <IconWrapper className={'iconWrapper'} horizontalAlignment={props.horizontalAlignment} data-analytics-click-event={props.linkAnalyticEvent}>
                <a className={'iconLink'} href={props.linkUrl} target={props.isOpenLinkInNewTab ? '_blank' : '_self'}>
                    <div className="icon-container">
                        {ResizeRatio && <ResizeRatio width={size} staticSize={true} property="fontSize" min={12} max={150} suffix={'px'} elementDomWidth={Number(size)} elementContainerWidth={Number(size)} emitWidth={emitSize} />}
                        <IconElement className="material-icons" fontSize={size} color={props.color}>{props.icon}</IconElement>
                    </div>
                </a>
            </IconWrapper>
        );
    } else {
        return (
            <IconWrapper className={'iconWrapper'} horizontalAlignment={props.horizontalAlignment}>
                <div className="icon-container">
                    {ResizeRatio && <ResizeRatio width={size} property="fontSize" min={12} max={150} suffix={'px'} staticSize={true} elementDomWidth={Number(size)} elementContainerWidth={Number(size)} emitWidth={emitSize} />}
                    <IconElement className="material-icons" fontSize={size} color={props.color}>{props.icon}</IconElement>
                </div>
            </IconWrapper>
        );
    }
};

const environmentLink: string = environment().assetsLink;
const settings:any = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [//group
            {
                settingName: 'AddIcon',
                isMainSettings: true
            },
        ],
        [//group
            {
                settingName: 'Size',
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'fontSize',
                        defaultValue: 70,
                        suffix: 'px',
                        min: 12,
                        max: 150
                    }
                ],
            },
            {
                settingName: 'BackgroundColor',
                controls: [
                    {
                        controlName: 'CustomColors',
                        property: 'color',
                        title: 'Icon Color',
                        defaultValue: '#fff',
                    },
                ],
            }
        ],
        [
            {
                settingName: 'Link',
            },
            {
                settingName: 'Anchor',
            }
        ]
    ];

const options = [
    {
        name:'change',
        title: 'Change',
        icon: environmentLink + '/assets/images/Options/icon.svg',
        action: 'setActiveSetting',
        settingTitle: 'Icon'
    }
]

export default {
    Icon,
    settings,
    options,
    label: 'Icon'
};


